<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-09-26 10:12:56
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-11-08 10:50:38
 * @FilePath: \official_website\src\views\products\details\Marrow.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 血液细胞形态学AI扫描分析系统 -->
<template>
  <div id="marrow">
    <Header></Header>
    <div class="marrow-conter">
      <div class="marrow-img">
        <Breadcrumb
          :productType="productType"
          :productName="productName"
        ></Breadcrumb>
        <div class="illustrate-box">
          <div class="title wow animate__animated animate__fadeInUp">
            血液细胞形态学AI扫描分析系统
          </div>
          <div class="series wow animate__animated animate__fadeInUp">
            CR-GS系列
          </div>
          <div class="line"></div>
          <ul class="keywords wow animate__animated animate__fadeInUp">
            <li>灵活</li>
            <li>快速</li>
            <li>完整</li>
            <li>精准</li>
            <li>稳定</li>
          </ul>
        </div>
        <div class="product-img">
          <!-- <img src="@/assets/image/product/film-1.png" alt="" /> -->
        </div>
      </div>
      <div class="marrow-description">
        <div class="parameter">
          <div class="parameter-item">
            <div class="parameter-box parameter-one"></div>
            <div
              class="parameter-box parameter-text wow animate__animated animate__fadeInUp"
            >
              <div class="title">灵活</div>
              <div class="detail">
                分析仪具备5片、40片、80片、160片、240片等多种通量，满足不同场景需求
              </div>
            </div>
          </div>
          <div class="parameter-item">
            <div
              class="parameter-box parameter-text wow animate__animated animate__fadeInUp"
            >
              <div class="title">快速</div>
              <div class="detail">
                <!-- 扫描高效，细胞扫描200个细胞时间小于400秒边缘全扫描，不放过任何血小板，漏诊率更低 -->
                扫描高效，支持60X或100X全片飞拍扫描，支持多层扫描，全区域(15*20mm)扫描时间小于3分钟，全片(23*45mm)扫描时间小于5分钟
              </div>
            </div>
            <div class="parameter-box parameter-two"></div>
          </div>
          <div class="parameter-item">
            <div class="parameter-box parameter-three"></div>
            <div
              class="parameter-box parameter-text wow animate__animated animate__fadeInUp"
            >
              <div class="title">精准</div>
              <div class="detail">
                <!-- 外周血、骨髓涂片样本均可识别;对粒系.红系等50余类细胞精准识别，异常提示 -->
                外周血、骨髓涂片样本均可识别；对粒系、红系、巨核、单核、淋巴、浆细胞等90余类细胞精准识别，异常提示；不放过任何血小板，漏诊率更低
              </div>
            </div>
          </div>
          <div class="parameter-item">
            <div
              class="parameter-box parameter-text wow animate__animated animate__fadeInUp"
            >
              <div class="title">稳定</div>
              <div class="detail">
                提供推片、染色、扫描、分析自动化解决方案，结果更稳定
              </div>
            </div>
            <div class="parameter-box parameter-four"></div>
          </div>
        </div>
      </div>

      <RelatedProduct :swiperData="relatProd"></RelatedProduct>
    </div>
    <div class="footer">
      <Footer></Footer>
    </div>
  </div>
</template>
    
<script>
import Header from "@/views/componets/Header.vue";
import Footer from "@/views/componets/Footer.vue";
import RelatedProduct from "../componets/RelatedProduct.vue";
import Breadcrumb from "@/views/componets/Breadcrumb.vue";
import api from "../../../api/api";

export default {
  name: "",
  props: {},
  components: {
    Header,
    Footer,
    RelatedProduct,
    Breadcrumb,
  },
  data() {
    return {
      productType: "产品",
      productName: "血液细胞形态学AI扫描分析系统",
      relatProd: [
        {
          title: "全自动推片染色机",
          src: require("@/assets/image/product/blood-2.png"),
          path: "/product/bloodPushing",
        },
      ],
      urlPath: "", // 当前路由
      allProdList: [], // 所有产品数据
      currentList: {}, // 当前页面数据
    };
  },
  async created() {
    await this.getPordList(1, 100, {});
    await this.getChooseId(this.currentList.id);
  },
  mounted() {
    this.$nextTick(() => {
      new this.$wow.WOW({
        boxClass: "wow", // 动画元件css类（默认为wow）
        animateClass: "animate__animated", //动画css类（默认为animated）
        offset: 0, //到元素距离触发动画（当默认为0）
        mobile: true, //在移动设备上触发动画（默认为true）
        live: true, //对异步加载的内容进行操作（默认为true）
      }).init();
    });
  },
  watch: {
    $route: {
      // $route可以用引号，也可以不用引号  监听的对象
      handler(to, from) {
        // console.log(to.path);
        this.urlPath = to.path;
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  },
  methods: {
    // 获取所有产品信息
    async getPordList(pageIndex, pageSize, params) {
      try {
        var res = await api.getPorductList(pageIndex, pageSize, params);
        if (res && res.data && res.data.code === 200) {
          this.allProdList = res.data.models;
          let presentProd = this.allProdList.filter((item) => {
            return item.summary == this.urlPath;
          });
          this.currentList = presentProd.length != 0 ? presentProd[0] : 0;
        } else {
        }
      } catch (error) {}
    },
    // 获取相关产品信息
    async getChooseId(prodId) {
      try {
        var res = await api.getProdRelationByid(prodId);
        if (res && res.data && res.data.code === 200) {
          if (res.data.models) {
            let result = res.data.models[0].relationID;
            if (result) {
              let relationArr = result.split(",");
              let tepmArr = [];
              relationArr.forEach((item) => {
                tepmArr.push(Number(item));
              });

              let relatedList = [];
              tepmArr.forEach((items) => {
                let secData = this.allProdList.filter((item) => {
                  return item.id == items;
                });
                if (secData.length != 0) {
                  relatedList.push(secData[0]);
                }
              });

              this.relatProd = relatedList;
            } else {
            }
          }
        } else {
        }
      } catch (error) {}
    },
  },
};
</script>
    
<style lang="scss">
#marrow {
  width: 100%;
  height: 100%;
  .marrow-conter {
    padding-top: 5rem;
    .marrow-img {
      position: relative;
      height: 50rem;
      background-image: url("../../../assets/image/product-detail/product-bg.png");
      background-size: cover;
      // img {
      //  position: absolute;
      //  left: 45%;
      //  top: 5%;
      // }
      .illustrate-box {
        position: absolute;
        left: 18%;
        top: 25%;
        width: 21.875rem;
        .title {
          font-size: 1.8rem;
          font-family: "SourceHanSansSC-Medium";
          margin-bottom: 1rem;
        }
        .series {
          font-size: 1.8rem;
          font-family: "SourceHanSansSC-Medium";
          margin-bottom: 2.8125rem;
        }
        .line {
          width: 4.25rem;
          height: 3px;
          margin-bottom: 1.25rem;
          background: #177a73;
        }
        .keywords {
          display: flex;
          li {
            width: 18.4%;
            height: 2.1875rem;
            line-height: 2.1875rem;
            margin-right: 2%;
            color: #fff;
            background: #177a73;
            border-radius: 2.1875rem;
            text-align: center;
            &:last-of-type {
              margin-right: 0;
            }
          }
        }
      }
      .product-img {
        position: absolute;
        left: 45%;
        top: 12%;
        width: 50%;
        height: 75%;
        background-image: url("../../../assets/image/marrow/blood.png");
        background-size: contain;
        background-repeat: no-repeat;
      }
    }
    .marrow-description {
      width: 100%;
      padding: 3.75rem 18%;
      .parameter {
        width: 100%;
        margin: 2rem 0 3rem;
        .parameter-item {
          display: flex;
          height: 24rem;
          margin-bottom: 2rem;
          &:first-of-type {
            height: 23rem;
          }
          .parameter-box {
            width: 48%;
            margin-right: 4%;
            margin-bottom: 1.5rem;
            &:nth-of-type(2n) {
              margin-right: 0;
            }
          }
          .parameter-one {
            background-image: url("../../../assets/image/marrow/des-1.png");
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
            border-radius: 2rem;
          }
          .parameter-two {
            background-image: url("../../../assets/image/marrow/des-2.jpg");
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
            border-radius: 2rem;
          }
          .parameter-three {
            background-image: url("../../../assets/image/marrow/des-3.png");
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
            border-radius: 2rem;
          }
          .parameter-four {
            background-image: url("../../../assets/image/marrow/des-4.png");
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
            border-radius: 2rem;
          }
          .parameter-text {
            padding: 7rem 3rem 5rem;
            .title {
              font-size: 1.8rem;
              font-family: "SourceHanSansSC-Medium";
              margin-bottom: 1rem;
            }
            .detail {
              font-size: 1.3rem;
              font-family: "OPlusSans3-Regular";
              line-height: 2.5rem;
            }
          }
        }
      }
    }
  }
  .footer {
    width: 100%;
    height: 100%;
    background: #f5f5f5;
    padding: 6.25rem 8% 3.125rem;
  }
}
</style>